//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ourTeasQuiz from "~/components/modal/our-teas-quiz";
import productItemPl from "~/components/loading-placeholders/product-item-pl";
import SocialShareBtns from "~/components/social-share-btns";
import BannerTypeProduct from "~/components/content-elements/banner-type-product";
export default {
  components: {
    ourTeasQuiz,
    productItemPl,
    SocialShareBtns,
    BannerTypeProduct,
  },
  async asyncData({ store }) {
    await store.dispatch("tea-products/getTeaCategories");
    const seo = store.state["tea-products"].teaCategories.tea_formats.seo;
    return {
      seo,
    };
  },
  head() {
    return {
      title: this.seo.meta_title,
      meta: [
        {
          name: "description",
          hid: "description",
          content: this.seo.meta_description,
        },
        {
          name: "og:description",
          hid: "og:description",
          content: this.seo.meta_description,
        },
        {
          name: "keywords",
          hid: "keywords",
          content: this.seo.keywords,
        },
        {
          property: "og:url",
          content: `https://www.dilmahtea.com${this.$route.path}`,
        },

        {
          property: "og:image",
          hid: "og:image",
          content: this.seo.share_image_url,
        },
        {
          property: "og:title",
          hid: "og:title",
          content: this.seo.meta_title,
        },
        {
          property: "og:image:alt",
          hid: "og:image:alt",
          content: this.seo.share_image_alt,
        },

        {
          name: "shareImageAlt",
          hid: "shareImage",
          content: this.seo.share_image_alt,
        },
        {
          name: "shareImage",
          hid: "shareImage",
          content: this.seo.share_image_url,
        },
        {
          name: "preventindex",
          hid: "preventindex",
          content: this.seo.prevent_indexing,
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("tea-products/getTeaCategories");
    this.scrollToNavPos();
  },
  computed: {
    pageData() {
      if (this.$store.state["tea-products"].teaCategories != null) {
        return this.$store.state["tea-products"].teaCategories;
      } else {
        return null;
      }
    },
  },
  methods: {
    scrollToNavPos() {
      if ($(".tea-catogory-tab .nav")) {
        $(".tea-catogory-tab .nav").scrollLeft(
          $(".nav-item.tea-tab.active").offset().left - 120
        );
      }
    },
  },
};
